module.exports = __webpack_public_path__ + "static/img/logo_15.94abbb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_15.png
// module id = uru1
// module chunks = 1